var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 7h-2.5c-.827 0-1.5-.673-1.5-1.5V2H4v16h12V7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 6v-.293l-3-3V5.5c0 .275.225.5.5.5H16z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#605E5C",
    d: "M16.707 5 13 1.293A1 1 0 0 0 12.293 1H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V5.707A1 1 0 0 0 16.707 5zM16 5.707V6h-2.5a.501.501 0 0 1-.5-.5V2.707l3 3zM4 2.2v15.6c0 .11.09.2.2.2h11.6a.2.2 0 0 0 .2-.2V7h-2.5A1.5 1.5 0 0 1 12 5.5V2H4.2a.2.2 0 0 0-.2.2z",
    opacity: 0.64
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8C6C4",
    d: "M14.5 10h-9a.5.5 0 0 1 0-1h9a.5.5 0 0 1 0 1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D65532",
    d: "M6 16v-4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zm1.2 0h5.594a.195.195 0 0 0 .2-.196c-.006-.678.002-2.932.006-3.61 0-.11-.09-.194-.2-.194H7.2a.2.2 0 0 0-.2.2v3.6c0 .11.09.2.2.2zm-2.45 0H3a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h1.75a.25.25 0 0 1 .25.25v3.5a.25.25 0 0 1-.25.25zm10.5 0H17a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-1.75a.25.25 0 0 0-.25.25v3.5c0 .138.112.25.25.25z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf_icon.bc5ce305bc4c2115bc42fa1f94df196a.svg";
export { ForwardRef as ReactComponent };